import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "comenzi-wrapper" }
const _hoisted_2 = { class: "popup-shell" }
const _hoisted_3 = { class: "popup-grad-header" }
const _hoisted_4 = { class: "popup-hdr-texts" }
const _hoisted_5 = { class: "popup-hdr-sub" }
const _hoisted_6 = { class: "popup-body" }
const _hoisted_7 = { class: "cell-total" }
const _hoisted_8 = {
  key: 0,
  class: "popup-footer-hint"
}
const _hoisted_9 = {
  key: 1,
  class: "popup-footer-hint"
}
const _hoisted_10 = { class: "popup-shell" }
const _hoisted_11 = { class: "popup-grad-header" }
const _hoisted_12 = { class: "popup-hdr-texts" }
const _hoisted_13 = { class: "popup-hdr-sub" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "genpo-body" }
const _hoisted_16 = { class: "genpo-form" }
const _hoisted_17 = { class: "genpo-row2" }
const _hoisted_18 = { class: "genpo-field genpo-span2" }
const _hoisted_19 = { class: "genpo-field" }
const _hoisted_20 = { class: "genpo-field" }
const _hoisted_21 = { class: "genpo-field genpo-span2" }
const _hoisted_22 = { class: "genpo-footer" }
const _hoisted_23 = { class: "popup-shell" }
const _hoisted_24 = { class: "popup-grad-header" }
const _hoisted_25 = { class: "popup-hdr-texts" }
const _hoisted_26 = { class: "popup-hdr-sub" }
const _hoisted_27 = { class: "popup-body" }
const _hoisted_28 = { class: "cell-total" }
const _hoisted_29 = {
  key: 0,
  class: "badge-anulat"
}
const _hoisted_30 = {
  key: 1,
  class: "badge-activ"
}
const _hoisted_31 = {
  key: 0,
  class: "popup-footer-hint"
}
const _hoisted_32 = {
  key: 1,
  class: "popup-footer-hint"
}
const _hoisted_33 = {
  key: 2,
  class: "popup-footer-hint"
}
const _hoisted_34 = { class: "popup-shell" }
const _hoisted_35 = { class: "popup-grad-header" }
const _hoisted_36 = { class: "popup-hdr-texts" }
const _hoisted_37 = { class: "popup-hdr-title" }
const _hoisted_38 = { class: "popup-hdr-sub" }
const _hoisted_39 = {
  key: 0,
  class: "badge-anulat-header"
}
const _hoisted_40 = { class: "popup-meta-strip" }
const _hoisted_41 = { class: "meta-block" }
const _hoisted_42 = { class: "meta-block-value" }
const _hoisted_43 = { class: "meta-block" }
const _hoisted_44 = { class: "meta-block-value" }
const _hoisted_45 = { class: "meta-block" }
const _hoisted_46 = { class: "meta-block-value" }
const _hoisted_47 = { class: "meta-block" }
const _hoisted_48 = { class: "meta-block-value meta-block-total" }
const _hoisted_49 = { class: "popup-body" }
const _hoisted_50 = { class: "cell-total" }

import { ref, shallowRef, watch, onMounted } from 'vue';
import DxDataGrid, { DxColumn, DxRemoteOperations, DxStateStoring, DxToolbar, DxItem, DxScrolling, DxSelection, DxPager } from 'devextreme-vue/data-grid';
import DxButton from 'devextreme-vue/button';
import DxPopup from 'devextreme-vue/popup';
import DxSelectBox from 'devextreme-vue/select-box';
import DxDateBox from 'devextreme-vue/date-box';
import DxTextBox from 'devextreme-vue/text-box';
import DataSource from 'devextreme/data/data_source';
import ODataStore from 'devextreme/data/odata/store';
import CustomStore from 'devextreme/data/custom_store';
import AppSetting from '@/settings/appSettings';
import notify from 'devextreme/ui/notify';
import { custom } from 'devextreme/ui/dialog';
import ProComenziService from '@/services/Comercial/ProComenzi';
import DOC_DocumenteService from '@/services/Documente/DOC_Documente';
import PopupAdaugareDetaliu from './PopupAdaugareDetaliu.vue';

interface Filter { category: number | null; start: string; end: string; }
interface OrderData { [key: string]: any; }


export default /*@__PURE__*/_defineComponent({
  __name: 'GridComenzi',
  props: {
    filters: {}
  },
  emits: ["openOrder"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;
const emit = __emit;

const comenziData = ref<DataSource | null>(null);
const showAddPopup = ref(false);
const selectedTipComanda = ref<number | null>(null);
const selectedComandaId = ref('');
const gridRef = ref<any>(null);

function onAdaugare() {
  showAddPopup.value = true;
}

// Apelat din PRO_ComenziView la revenirea pe listă după deschiderea unei comenzi — gridul
// rămâne montat (v-show, nu v-if), deci textul de căutare din filter-row ar rămâne altfel
// vizibil la nesfârșit pe coloană.
function clearColumnFilters() {
  gridRef.value?.instance?.clearFilter('row');
}

__expose({ clearColumnFilters });

function onGridStateSaving(state: any) {
  const cleaned = { ...state };
  delete cleaned.filterValue;
  if (Array.isArray(cleaned.columns)) {
    cleaned.columns = cleaned.columns.map((c: any) => {
      const { filterValue, filterValues, ...rest } = c;
      return rest;
    });
  }
  localStorage.setItem('grid-comenzi-state', JSON.stringify(cleaned));
}
function onGridStateLoading() {
  const raw = localStorage.getItem('grid-comenzi-state');
  return raw ? JSON.parse(raw) : null;
}

const STARE_COLORS: Record<string, { background: string; color: string }> = {
  'inasteptare': { background: '#f5f3ff', color: '#6d28d9' },
  'confirmata':  { background: '#eff6ff', color: '#1d4ed8' },
  'inlucru':     { background: '#fef3c7', color: '#92400e' },
  'finalizata':  { background: '#ecfdf5', color: '#065f46' },
  'anulata':     { background: '#fef2f2', color: '#991b1b' },
};

const STARE_LABELS: Record<string, string> = {
  'InAsteptare': 'In Asteptare',
  'InLucru':     'In Lucru',
};
function getStareLabel(stare: string | null | undefined): string {
  return STARE_LABELS[stare ?? ''] ?? (stare ?? '');
}

function getStareStyle(stare: string | null | undefined): Record<string, string> {
  const key = (stare ?? '').toLowerCase().trim();
  const theme = STARE_COLORS[key] ?? { background: '#f1f5f9', color: '#475569' };
  return {
    background: theme.background,
    color: theme.color,
    padding: '4px 12px',
    borderRadius: '20px',
    fontWeight: '700',
    fontSize: '11px',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    display: 'inline-block',
    whiteSpace: 'nowrap',
  };
}

function getRezervatLabel(row: any): string {
  if (row?.CantitateComandataSumar == null) return '—';
  return `${formatRO(row.CantitateComandataSumar)} / ${formatRO(row.CantitateRezervataSumar)}`;
}

function getRezervatStyle(row: any): Record<string, string> {
  const base = {
    padding: '3px 10px',
    borderRadius: '20px',
    fontWeight: '700',
    fontSize: '11px',
    display: 'inline-block',
    whiteSpace: 'nowrap',
  };
  const total = row?.CantitateComandataSumar;
  const rezervat = row?.CantitateRezervataSumar;
  if (total == null || total <= 0 || !(rezervat > 0)) {
    return { ...base, background: '#f1f5f9', color: '#64748b' };
  }
  if (rezervat >= total) {
    return { ...base, background: '#ecfdf5', color: '#065f46' };
  }
  return { ...base, background: '#fef3c7', color: '#92400e' };
}

// ── Store cu sumar rezervări atașat pe fiecare rând, la nivel de pagină încărcată ──
function buildComenziStore(url: string): CustomStore {
  const baseStore = new ODataStore({
    url,
    key: 'Id',
    version: 4,
    beforeSend: (e: any) => {
      e.headers = {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt"),
      };
      e.params.$expand = 'Agent($select=Nume),Client($select=Nume),Proiect($select=Cod,Nume),Valuta($select=Simbol),Contract($select=NumeContract,NumarContract),Facturator($select=Nume),Punct($select=Nume),Delegat($select=Delegat)';
    },
  });

  return new CustomStore({
    key: 'Id',
    load: async (loadOptions: any) => {
      const result: any = await baseStore.load(loadOptions);
      const rows: any[] = Array.isArray(result) ? result : (result.data ?? []);
      const totalCount: number | undefined = Array.isArray(result) ? undefined : result.totalCount;

      const ids: string[] = rows.map((r: any) => r.Id).filter(Boolean);
      if (ids.length > 0) {
        try {
          const resp = await ProComenziService.getSumarRezervari(ids);
          const dict = resp.data ?? {};
          // Normalizare case-insensitive + conversie explicită la string: GUID-urile din
          // OData și cele din dicționarul REST (Dictionary<Guid,...>) pot diferi ca literă
          // mare/mică sau ca tip la momentul comparării.
          const sumar = new Map(Object.keys(dict).map(k => [String(k).toLowerCase(), dict[k]]));
          rows.forEach((row: any) => {
            const info = sumar.get(String(row.Id ?? '').toLowerCase());
            row.CantitateComandataSumar = info?.CantitateTotal ?? null;
            row.CantitateRezervataSumar = info?.CantitateRezervata ?? null;
          });
        } catch {
          rows.forEach((row: any) => {
            row.CantitateComandataSumar = null;
            row.CantitateRezervataSumar = null;
          });
        }
      }

      return totalCount !== undefined ? { data: rows, totalCount } : rows;
    },
    totalCount: (loadOptions: any) => baseStore.totalCount(loadOptions),
    byKey: (key: any) => baseStore.byKey(key),
  });
}

watch(() => props.filters, (filters) => {
  const queryParams: string[] = [];
  if (filters.category !== null) queryParams.push(`Tipcomanda=${filters.category}`);
  if (filters.start) queryParams.push(`DataStart=${filters.start}`);
  if (filters.end) queryParams.push(`DataEnd=${filters.end}`);

  const url = AppSetting.API_Url_ComercialOdata + 'PRO_Comenzi' + (queryParams.length ? `?${queryParams.join('&')}` : '');

  comenziData.value = new DataSource({
    store: buildComenziStore(url),
    paginate: true,
    pageSize: 15,
  });
}, { immediate: true });

function onCellPrepared(e: any) {
  if (e.cellElement && (e.rowType === 'data' || e.rowType === 'header')) {
    e.cellElement.style.setProperty('padding-top', '0px', 'important');
    e.cellElement.style.setProperty('padding-bottom', '0px', 'important');
  }
}

function onOpenOrder(order: OrderData) {
  emit('openOrder', order);
}

function onSaved(commandData: Record<string, any>) {
  comenziData.value?.reload();
  if (commandData?.Id) {
    emit('openOrder', { ...commandData, _isNew: true });
  }
}

// ── Context menu + documente generate ──
const selectedContextOrder = ref<any>(null);
const showDocumentePopup = ref(false);
const showDocumentViewPopup = ref(false);
const selectedDocument = ref<any>(null);
const dsDocumente = shallowRef<any[]>([]);
const isLoadingDocumente = ref(false);
const dsLinii = shallowRef<any>(null);

const isDuplicating = ref(false);
const isImpartind = ref(false);
const isGenerandStorno = ref(false);

const showFurnizoriPopup = ref(false);
const isLoadingFurnizori = ref(false);
const poFurnizoriList = ref<any[]>([]);

const tipuriFurnizoriSet = ref<Set<number>>(new Set());
const categoriiLoaded = ref(false);

const dsTipuriFacturi = shallowRef<DataSource | null>(null);
const dsBanciConturi = shallowRef<DataSource | null>(null);
const dsComenziProiect = shallowRef<DataSource | null>(null);
const selectedComenziIds = ref<string[]>([]);

const showFacturaProiectPopup = ref(false);
const isGenerandFacturaProiect = ref(false);
const facturaProiectDraft = ref<{ TipDocumentId: string | null; Data: Date; ContBancaCasaId: string | null; Observatii: string }>({
  TipDocumentId: null, Data: new Date(), ContBancaCasaId: null, Observatii: '',
});

function getErrMsg(err: any): string {
  if (err?.response?.data) {
    const data = err.response.data;
    if (typeof data === 'string') return data;
    if (data.error?.message) return data.error.message;
    if (data.Message) return data.Message;
    if (data.ExceptionMessage) return data.ExceptionMessage;
    if (data.title) return data.title;
  }
  return err?.message ?? 'A apărut o eroare.';
}

async function onImparteComanda(order: any) {
  if (isImpartind.value) return;
  const ok = await custom({
    title: 'Confirmare împărțire comandă',
    messageHtml: `<div style="padding:4px 0">Comanda <b>${order.Cod}</b> va fi împărțită în două:<br><br>
      • Cantitățile rezervate rămân pe comanda curentă<br>
      • Cantitățile nerezervate sunt mutate pe o comandă nouă<br>
      • Ambele comenzi păstrează același PO<br><br>
      Ești sigur că vrei să continui?</div>`,
    buttons: [
      { text: 'Da, împarte', type: 'default', onClick: () => true },
      { text: 'Renunță', stylingMode: 'outlined', onClick: () => false },
    ],
  }).show();
  if (!ok) return;
  isImpartind.value = true;
  try {
    const resp = await ProComenziService.imparteComanda(order.Id);
    const { ComandaNoua } = resp.data;
    comenziData.value?.reload();
    setTimeout(() => notify(`Comanda a fost împărțită. Comanda nouă: ${ComandaNoua?.Cod ?? ''}`, 'success', 4000), 150);
    if (ComandaNoua?.Id) emit('openOrder', { ...ComandaNoua, _isNew: false });
  } catch (err: any) {
    setTimeout(() => notify(getErrMsg(err), 'error', 4000), 150);
  } finally {
    isImpartind.value = false;
  }
}

async function onGenereazaStorno(order: any, liniiIds?: string[]) {
  if (isGenerandStorno.value) return;
  const estePartial = liniiIds && liniiIds.length > 0;
  const ok = await custom({
    title: 'Generare comandă storno client',
    messageHtml: estePartial
      ? `<div style="padding:4px 0">Se generează storno pentru <b>${liniiIds!.length} linie(i) selectate</b> din comanda <b>${order.Cod}</b>.<br>Comanda storno va fi creată cu starea <b>Confirmată</b>.<br><br>Continui?</div>`
      : `<div style="padding:4px 0">Se generează comanda storno pentru <b>toate liniile</b> din comanda <b>${order.Cod}</b>.<br>Comanda storno va fi creată cu starea <b>Confirmată</b>.<br><br>Continui?</div>`,
    buttons: [
      { text: 'Da, generează', type: 'default', onClick: () => true },
      { text: 'Renunță', stylingMode: 'outlined', onClick: () => false },
    ],
  }).show();
  if (!ok) return;
  isGenerandStorno.value = true;
  try {
    const resp = await ProComenziService.genereazaStorno(order.Id, liniiIds);
    const storno = resp.data;
    comenziData.value?.reload();
    notify(`Comandă storno generată: ${storno?.Cod ?? ''}`, 'success', 3000);
    if (storno?.Id) emit('openOrder', { ...storno, _isNew: false });
  } catch (err: any) {
    notify(getErrMsg(err), 'error', 4000);
  } finally {
    isGenerandStorno.value = false;
  }
}

async function onDuplicaComanda(order: any, pastreazaPO: boolean) {
  if (isDuplicating.value) return;
  isDuplicating.value = true;
  try {
    const resp = await ProComenziService.duplicaComanda(order.Id, pastreazaPO);
    const comandaNoua = resp.data;
    comenziData.value?.reload();
    notify(`Comanda a fost duplicată: ${comandaNoua?.Cod ?? ''}`, 'success', 3000);
    if (comandaNoua?.Id) emit('openOrder', { ...comandaNoua, _isNew: false });
  } catch (err: any) {
    notify(getErrMsg(err), 'error', 4000);
  } finally {
    isDuplicating.value = false;
  }
}

async function onAfiseazaComenziFurnizori(order: any) {
  selectedContextOrder.value = order;
  poFurnizoriList.value = [];
  showFurnizoriPopup.value = true;
  isLoadingFurnizori.value = true;
  try {
    const resp = await ProComenziService.getPOuriByComanda(order.Id);
    poFurnizoriList.value = resp.data?.value ?? [];
  } catch {
    poFurnizoriList.value = [];
  } finally {
    isLoadingFurnizori.value = false;
  }
}

function onDeschidePO(po: any) {
  showFurnizoriPopup.value = false;
  emit('openOrder', po);
}

// Coduri TipComanda pentru comenzi storno — aceleași ca în backend (vezi și
// isComandaStorno din GridComandaDetalii.vue). TipComanda=9 ("Comenzi Retururi către
// Furnizori") are TipFurnizor=true la fel ca o comandă furnizor normală (TipComanda=5) —
// fără excluderea explicită, generarea automată de comenzi furnizori putea "nimeri" pe
// categoria de retur dacă aceasta apărea prima în listă, punând greșit Tipcomanda=9 în loc
// de 5 pe comenzile generate.
const TIPURI_STORNO = [3, 9];

async function loadCategorii() {
  if (categoriiLoaded.value) return;
  try {
    const resp = await ProComenziService.getCategoriiComenzi();
    const toate = resp.data?.value ?? [];
    const furnizoriNestorno = toate.filter((c: any) => c.TipFurnizor === true && !TIPURI_STORNO.includes(Number(c.TipComanda)));
    tipuriFurnizoriSet.value = new Set(furnizoriNestorno.map((c: any) => Number(c.TipComanda)));
  } catch {
    tipuriFurnizoriSet.value = new Set();
  } finally {
    categoriiLoaded.value = true;
  }
}

onMounted(() => { loadCategorii(); });

function buildDsTipuriFacturi() {
  const token = localStorage.getItem('ERA_Jwt') ?? '';
  dsTipuriFacturi.value = new DataSource({
    store: new ODataStore({
      url: AppSetting.API_Url_DocumenteOdata + 'DOC_Tipuri',
      key: 'Id', version: 4,
      beforeSend: (e: any) => { e.headers = { Authorization: 'Bearer ' + token }; },
    }),
    select: ['Id', 'Cod', 'Nume'],
    filter: [
      [['EsteCreanta', '=', true], 'or', ['EsteObligatie', '=', true]],
      'and', ['AreCasa', '=', false],
      'and', ['AreBanca', '=', false],
    ],
    sort: [{ selector: 'Nume', desc: false }],
    paginate: true, pageSize: 50,
  });
}

function buildDsBanciConturi() {
  const token = localStorage.getItem('ERA_Jwt') ?? '';
  dsBanciConturi.value = new DataSource({
    store: new ODataStore({
      url: AppSetting.API_Url_DocumenteOdata + 'ERP_BanciConturi',
      key: 'Id', version: 4,
      beforeSend: (e: any) => { e.headers = { Authorization: 'Bearer ' + token }; },
    }),
    select: ['Id', 'Cod', 'Nume', 'CodIban'],
    filter: ['Activ', '=', true],
    sort: [{ selector: 'Cod', desc: false }],
    paginate: true, pageSize: 50,
  });
}

function buildDsComenziProiect(proiectId: string) {
  const token = localStorage.getItem('ERA_Jwt') ?? '';
  dsComenziProiect.value = new DataSource({
    store: new ODataStore({
      url: AppSetting.API_Url_ComercialOdata + 'PRO_Comenzi',
      key: 'Id', version: 4,
      beforeSend: (e: any) => { e.headers = { Authorization: 'Bearer ' + token }; },
    }),
    select: ['Id', 'Cod', 'DataComenzii', 'NumarContract', 'TotalComanda'],
    filter: [
      ['ProiectId', '=', proiectId],
      'and', ['Stare', '=', 'InLucru'],
      'and', ['Tipcomanda', '<>', 3],
      'and', ['Tipcomanda', '<>', 9],
    ],
    sort: [{ selector: 'DataComenzii', desc: false }],
    paginate: false,
  });
}

async function onOpenFacturaProiectPopup(order: any) {
  if (!dsTipuriFacturi.value) buildDsTipuriFacturi();
  if (!dsBanciConturi.value) buildDsBanciConturi();
  selectedContextOrder.value = order;
  facturaProiectDraft.value = { TipDocumentId: null, Data: new Date(), ContBancaCasaId: null, Observatii: '' };
  selectedComenziIds.value = [];
  if (order?.ProiectId) buildDsComenziProiect(order.ProiectId);
  showFacturaProiectPopup.value = true;
}

function onComenziProiectContentReady(e: any) {
  // Selectate implicit toate comenzile eligibile la încărcare — userul poate debifa
  // ce nu vrea să includă (comportamentul vechi era "toate automat", păstrat ca default).
  if (selectedComenziIds.value.length === 0) {
    const ids = (e.component.getDataSource()?.items() ?? []).map((c: any) => c.Id);
    if (ids.length > 0) {
      selectedComenziIds.value = ids;
      e.component.selectRows(ids, false);
    }
  }
}

function onComenziProiectSelectionChanged(e: any) {
  selectedComenziIds.value = e.selectedRowKeys;
}

async function onGenereazaFacturaProiect() {
  if (!facturaProiectDraft.value.TipDocumentId || !selectedContextOrder.value?.ProiectId) return;
  if (selectedComenziIds.value.length === 0) {
    notify('Selectați cel puțin o comandă din listă.', 'error', 4000);
    return;
  }
  isGenerandFacturaProiect.value = true;
  try {
    const rezultat = await DOC_DocumenteService.genereazaFacturaProiect({
      ProiectId: selectedContextOrder.value.ProiectId,
      TipDocumentId: facturaProiectDraft.value.TipDocumentId,
      Data: facturaProiectDraft.value.Data,
      ContBancaCasaId: facturaProiectDraft.value.ContBancaCasaId || null,
      Observatii: facturaProiectDraft.value.Observatii || null,
      ComandaIds: selectedComenziIds.value,
    });
    showFacturaProiectPopup.value = false;
    const doc = rezultat.data?.Document;
    const avertismente: string[] = rezultat.data?.Avertismente ?? [];
    const numarMsg = doc?.Numar ? ` Nr: ${doc.Numar}` : '';
    notify(`Factura de proiect a fost generată cu succes.${numarMsg}`, 'success', 4000);
    if (avertismente.length > 0)
      setTimeout(() => notify(avertismente[0], 'warning', 6000), 400);
  } catch (err: any) {
    notify(getErrMsg(err), 'error', 5000);
  } finally {
    isGenerandFacturaProiect.value = false;
  }
}

function onContextMenuPreparing(e: any) {
  if (e.target !== 'content' || e.row?.rowType !== 'data') return;
  const order = e.row.data;

  const isFurnizor = tipuriFurnizoriSet.value.has(Number(order.Tipcomanda));
  const stare = (order.Stare ?? '') as string;
  const starePermiteFactura = stare === 'InLucru';
  // Împărțirea (rezervat/nerezervat) nu ține de starea InLucru — se poate face oricând comanda
  // e activă; blocajul real ("toate produsele sunt deja complet rezervate, nimic de mutat") e
  // validat de backend la click, cu mesaj clar (PRO_ComenziRepository.ImparteComanda).
  const starePermiteImpartire = !['Anulata', 'Finalizata'].includes(stare);

  e.items = [
    {
      text: 'Duplicare, PO nou',
      icon: 'copy',
      onItemClick: () => onDuplicaComanda(order, false),
    },
    {
      text: 'Duplicare, păstrare PO',
      icon: 'copy',
      onItemClick: () => onDuplicaComanda(order, true),
    },
    {
      text: 'Împarte cf. cantități rezervate',
      icon: 'splitcells',
      disabled: !starePermiteImpartire,
      onItemClick: () => onImparteComanda(order),
    },
    {
      text: 'Afișare comenzi furnizori',
      icon: 'find',
      onItemClick: () => onAfiseazaComenziFurnizori(order),
    },
    {
      beginGroup: true,
      text: 'Generează comandă storno (toate liniile)',
      icon: 'revert',
      onItemClick: () => onGenereazaStorno(order),
    },
    {
      text: 'Generează factură proiect...',
      icon: 'group',
      visible: false, // ascuns temporar, la cerere — funcționalitatea (selecție comenzi + validare PO unic) e completă în cod, dar rămâne de finalizat/testat altă dată
      disabled: !starePermiteFactura,
      onItemClick: () => onOpenFacturaProiectPopup(order),
    },
    {
      beginGroup: true,
      text: 'Documente generate',
      icon: 'doc',
      onItemClick: async () => {
        selectedContextOrder.value = order;
        dsDocumente.value = [];
        showDocumentePopup.value = true;
        isLoadingDocumente.value = true;
        try {
          const resp = await ProComenziService.getDocumenteGenerate(order.Id);
          dsDocumente.value = resp.data ?? [];
        } catch {
          dsDocumente.value = [];
        } finally {
          isLoadingDocumente.value = false;
        }
      },
    },
  ];
}

function onDocRowClick(e: any) {
  // Nume fix de fereastră — browserul reutilizează același tab la apeluri succesive,
  // în loc să deschidă un tab nou de fiecare dată; Documente.vue adaugă documentul
  // ca tab intern nou (vezi mounted() → openDocumentDetailTab din query ?id=).
  window.open('/documente?id=' + e.data.Id, 'era_documente_tab');
}

function formatRO(val: number | null | undefined): string {
  if (val == null) return '';
  return val.toLocaleString('ro-RO', { maximumFractionDigits: 10 });
}

function formatDocDate(val: string | null | undefined): string {
  if (!val) return '—';
  return new Date(val).toLocaleDateString('ro-RO', { day: '2-digit', month: '2-digit', year: 'numeric' });
}

function formatDocMoney(val: number | null | undefined): string {
  if (val == null) return '—';
  return val.toLocaleString('ro-RO', { maximumFractionDigits: 10 });
}

function getLinieNume(row: any): string {
  return row?.Produs?.Nume || row?.Nume || '—';
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(DxDataGrid), {
        ref_key: "gridRef",
        ref: gridRef,
        "data-source": comenziData.value,
        "key-expr": "Id",
        "show-borders": "",
        "column-auto-width": false,
        onContextMenuPreparing: onContextMenuPreparing,
        onRowDblClick: _cache[0] || (_cache[0] = (e) => onOpenOrder(e.data)),
        "allow-column-resizing": true,
        "column-resizing-mode": 'widget',
        "allow-column-reordering": true,
        "show-column-lines": true,
        "show-row-lines": true,
        "row-alternation-enabled": true,
        "hover-state-enabled": true,
        "filter-row": { visible: true },
        "column-chooser": { enabled: true, mode: 'select', allowSearch: true },
        paging: { pageSize: 10 },
        height: "100%",
        class: "comenzi-grid",
        onCellPrepared: onCellPrepared
      }, {
        stareCellTemplate: _withCtx(({ data }) => [
          _createElementVNode("span", {
            style: _normalizeStyle(getStareStyle(data.value))
          }, _toDisplayString(getStareLabel(data.value)), 5)
        ]),
        rezervatCellTemplate: _withCtx(({ data }) => [
          _createElementVNode("span", {
            style: _normalizeStyle(getRezervatStyle(data.data))
          }, _toDisplayString(getRezervatLabel(data.data)), 5)
        ]),
        boolDaNuCellTemplate: _withCtx(({ data }) => [
          _createElementVNode("span", {
            class: _normalizeClass(data.value ? 'badge-boolean-da' : 'badge-boolean-nu')
          }, _toDisplayString(data.value ? 'Da' : 'Nu'), 3)
        ]),
        adaugareBtn: _withCtx(() => [
          _createVNode(_unref(DxButton), {
            icon: "plus",
            type: "success",
            hint: "Adăugare",
            onClick: onAdaugare
          })
        ]),
        deschideCellTemplate: _withCtx(({ data }) => [
          _createVNode(_unref(DxButton), {
            icon: "eyeopen",
            hint: "Deschide Comanda",
            type: "default",
            "styling-mode": "outlined",
            class: "deschide-btn",
            onClick: () => onOpenOrder(data.data)
          }, null, 8, ["onClick"])
        ]),
        default: _withCtx(() => [
          _createVNode(_unref(DxScrolling), { "show-scrollbar": "always" }),
          _createVNode(_unref(DxRemoteOperations), {
            filtering: true,
            paging: true,
            sorting: true
          }),
          _createVNode(_unref(DxPager), {
            visible: true,
            "allowed-page-sizes": [10, 50, 100],
            "show-page-size-selector": true,
            "show-info": true,
            "show-navigation-buttons": true
          }),
          _createVNode(_unref(DxStateStoring), {
            enabled: true,
            type: "custom",
            "custom-save": onGridStateSaving,
            "custom-load": onGridStateLoading
          }),
          _createVNode(_unref(DxColumn), {
            caption: "",
            width: "50",
            fixed: true,
            "fixed-position": "left",
            "allow-sorting": false,
            "allow-filtering": false,
            "allow-resizing": false,
            "cell-template": "deschideCellTemplate"
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "DataComenzii",
            caption: "Data",
            "data-type": "date",
            format: "dd.MM.yyyy"
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "Cod",
            caption: "Cod"
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "Agent.Nume",
            caption: "Agent"
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "Client.Nume",
            caption: "Partener"
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "Observatii",
            caption: "Observatii"
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "Proiect.Nume",
            caption: "Proiect"
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "ValoareComanda",
            caption: "Valoare",
            "data-type": "number",
            format: formatRO
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "TotalComanda",
            caption: "Total",
            "data-type": "number",
            format: formatRO
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "Valuta.Simbol",
            caption: "Valuta"
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "Tva",
            caption: "TVA",
            "data-type": "number",
            format: formatRO
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "Facturat",
            caption: "Facturat",
            "data-type": "boolean",
            "cell-template": "boolDaNuCellTemplate"
          }),
          _createVNode(_unref(DxColumn), {
            caption: "Rezervat",
            width: 130,
            alignment: "center",
            "allow-sorting": false,
            "allow-filtering": false,
            "cell-template": "rezervatCellTemplate"
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "Stare",
            caption: "Stare",
            "cell-template": "stareCellTemplate"
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "Nume",
            caption: "Denumire",
            visible: false
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "LivrareDirectaFurnizor",
            caption: "Livrare Directă Furnizor",
            "data-type": "boolean",
            visible: false,
            "cell-template": "boolDaNuCellTemplate"
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "Motive",
            caption: "Motive",
            visible: false
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "Tipcomanda",
            caption: "Tip Comandă",
            visible: false
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "Numar",
            caption: "Număr",
            visible: false
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "NumeContract",
            caption: "Nume Contract",
            visible: false
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "NumarContract",
            caption: "Număr Contract",
            visible: false
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "Contract.NumeContract",
            caption: "Contract",
            visible: false
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "PathContract",
            caption: "Path Contract",
            visible: false
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "Facturator.Nume",
            caption: "Facturator",
            visible: false
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "ExpeditieTipId",
            caption: "Expeditie Tip",
            visible: false
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "Discount",
            caption: "Discount",
            "data-type": "number",
            format: formatRO,
            visible: false
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "FacturareZiDinLuna",
            caption: "Zi Facturare",
            visible: false
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "Curs",
            caption: "Curs",
            visible: false
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "PretCurs",
            caption: "Pret Curs",
            visible: false
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "PreturiCalculate",
            caption: "Preturi Calculate",
            visible: false
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "BonDeConfirmare",
            caption: "Bon Confirmare",
            visible: false
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "Delegat.Delegat",
            caption: "Delegat",
            visible: false
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "Punct.Nume",
            caption: "Punct",
            visible: false
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "DataStartProductie",
            caption: "Data Start Productie",
            "data-type": "date",
            visible: false
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "TimpExecutie",
            caption: "Timp Executie",
            visible: false
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "Prioritate",
            caption: "Prioritate",
            visible: false
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "Explicatie",
            caption: "Explicatie",
            visible: false
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "TermenLivrare",
            caption: "Termen Livrare",
            "data-type": "date",
            visible: false
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "Destinatar",
            caption: "Destinatar",
            visible: false
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "ExpCurierNume",
            caption: "Curier Nume",
            visible: false
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "Activa",
            caption: "Activa",
            visible: false
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "Anulata",
            caption: "Anulata",
            visible: false
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "Inchisa",
            caption: "Inchisa",
            visible: false
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "Suspendata",
            caption: "Suspendata",
            visible: false
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "Terminata",
            caption: "Terminata",
            visible: false
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "UserCreare",
            caption: "User Creare",
            visible: false
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "DataCreare",
            caption: "Data Creare",
            "data-type": "date",
            visible: false
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "UserModificare",
            caption: "User Modificare",
            visible: false
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "DataModificare",
            caption: "Data Modificare",
            "data-type": "date",
            visible: false
          }),
          _createVNode(_unref(DxToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(DxItem), {
                location: "after",
                template: "adaugareBtn"
              }),
              _createVNode(_unref(DxItem), { name: "columnChooserButton" })
            ]),
            _: 1
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "Proiect.Cod",
            caption: "PO",
            width: "140"
          })
        ]),
        _: 1
      }, 8, ["data-source"])
    ]),
    _createVNode(_unref(DxPopup), {
      visible: showFurnizoriPopup.value,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((showFurnizoriPopup).value = $event)),
      "show-title": false,
      "show-close-button": false,
      width: 900,
      height: 520,
      "drag-enabled": true,
      onHidden: _cache[4] || (_cache[4] = ($event: any) => (showFurnizoriPopup.value = false)),
      "wrapper-attr": { class: 'doc-popup-no-padding' }
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[18] || (_cache[18] = _createElementVNode("i", { class: "dx-icon dx-icon-taskcomplete popup-hdr-icon" }, null, -1)),
            _createElementVNode("div", _hoisted_4, [
              _cache[17] || (_cache[17] = _createElementVNode("span", { class: "popup-hdr-title" }, "Comenzi furnizori asociate", -1)),
              _createElementVNode("span", _hoisted_5, "Comandă sursă: " + _toDisplayString(selectedContextOrder.value?.Cod), 1)
            ]),
            _createElementVNode("button", {
              class: "popup-close-x",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (showFurnizoriPopup.value = false))
            }, "×")
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_unref(DxDataGrid), {
              "data-source": poFurnizoriList.value,
              "key-expr": "Id",
              "show-borders": false,
              "show-column-lines": false,
              "show-row-lines": true,
              "row-alternation-enabled": true,
              "hover-state-enabled": true,
              "column-auto-width": false,
              height: "420",
              onRowDblClick: _cache[2] || (_cache[2] = (e) => onDeschidePO(e.data))
            }, {
              starePOCell: _withCtx(({ data }) => [
                _createElementVNode("span", {
                  style: _normalizeStyle(getStareStyle(data.value))
                }, _toDisplayString(getStareLabel(data.value)), 5)
              ]),
              totalPOCell: _withCtx(({ data }) => [
                _createElementVNode("span", _hoisted_7, _toDisplayString(data.value != null ? formatRO(data.value) : '—'), 1)
              ]),
              deschidePOCell: _withCtx(({ data }) => [
                _createVNode(_unref(DxButton), {
                  icon: "eyeopen",
                  "styling-mode": "text",
                  hint: "Deschide PO",
                  onClick: ($event: any) => (onDeschidePO(data.data))
                }, null, 8, ["onClick"])
              ]),
              default: _withCtx(() => [
                _createVNode(_unref(DxColumn), {
                  "data-field": "Cod",
                  caption: "Cod PO",
                  width: 150
                }),
                _createVNode(_unref(DxColumn), {
                  "data-field": "Client.Nume",
                  caption: "Furnizor"
                }),
                _createVNode(_unref(DxColumn), {
                  "data-field": "DataComenzii",
                  caption: "Data",
                  "data-type": "date",
                  format: "dd.MM.yyyy",
                  width: 110
                }),
                _createVNode(_unref(DxColumn), {
                  "data-field": "Stare",
                  caption: "Stare",
                  width: 140,
                  "cell-template": "starePOCell"
                }),
                _createVNode(_unref(DxColumn), {
                  "data-field": "TotalComanda",
                  caption: "Total",
                  "data-type": "number",
                  format: formatRO,
                  width: 140,
                  alignment: "right",
                  "cell-template": "totalPOCell"
                }),
                _createVNode(_unref(DxColumn), {
                  "data-field": "Valuta.Simbol",
                  caption: "Val.",
                  width: 60,
                  alignment: "center"
                }),
                _createVNode(_unref(DxColumn), {
                  caption: "",
                  width: 52,
                  "allow-sorting": false,
                  "allow-filtering": false,
                  "allow-resizing": false,
                  "cell-template": "deschidePOCell"
                })
              ]),
              _: 1
            }, 8, ["data-source"]),
            (isLoadingFurnizori.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, "Se încarcă comenzile furnizori..."))
              : (!isLoadingFurnizori.value && poFurnizoriList.value.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [...(_cache[19] || (_cache[19] = [
                    _createElementVNode("i", { class: "dx-icon dx-icon-info" }, null, -1),
                    _createTextVNode(" Nicio comandă furnizor asociată acestei comenzi. ", -1)
                  ]))]))
                : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_unref(DxPopup), {
      visible: showFacturaProiectPopup.value,
      "onUpdate:visible": _cache[11] || (_cache[11] = ($event: any) => ((showFacturaProiectPopup).value = $event)),
      "show-title": false,
      "drag-enabled": true,
      "show-close-button": false,
      "close-on-outside-click": false,
      width: 720,
      height: 620,
      "wrapper-attr": { class: 'doc-popup-no-padding' }
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _cache[21] || (_cache[21] = _createElementVNode("i", { class: "dx-icon dx-icon-group popup-hdr-icon" }, null, -1)),
            _createElementVNode("div", _hoisted_12, [
              _cache[20] || (_cache[20] = _createElementVNode("span", { class: "popup-hdr-title" }, "Generează Factură Proiect", -1)),
              _createElementVNode("span", _hoisted_13, [
                _createTextVNode(" Proiect: " + _toDisplayString(selectedContextOrder.value?.Proiect?.Cod) + " ", 1),
                (selectedContextOrder.value?.Proiect?.Nume)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, " — " + _toDisplayString(selectedContextOrder.value?.Proiect?.Nume), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("button", {
              class: "popup-close-x",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (showFacturaProiectPopup.value = false))
            }, "×")
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _cache[22] || (_cache[22] = _createElementVNode("label", { class: "genpo-label" }, [
                    _createTextVNode("Tip Document "),
                    _createElementVNode("span", { class: "genpo-required" }, "*")
                  ], -1)),
                  _createVNode(_unref(DxSelectBox), {
                    value: facturaProiectDraft.value.TipDocumentId,
                    "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((facturaProiectDraft.value.TipDocumentId) = $event)),
                    "data-source": dsTipuriFacturi.value,
                    "display-expr": "Nume",
                    "value-expr": "Id",
                    "search-enabled": true,
                    "search-expr": "Nume",
                    placeholder: "Selectează tipul facturii..."
                  }, null, 8, ["value", "data-source"])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _cache[23] || (_cache[23] = _createElementVNode("label", { class: "genpo-label" }, [
                    _createTextVNode("Data "),
                    _createElementVNode("span", { class: "genpo-required" }, "*")
                  ], -1)),
                  _createVNode(_unref(DxDateBox), {
                    value: facturaProiectDraft.value.Data,
                    "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((facturaProiectDraft.value.Data) = $event)),
                    "display-format": "dd.MM.yyyy",
                    type: "date"
                  }, null, 8, ["value"])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _cache[24] || (_cache[24] = _createElementVNode("label", { class: "genpo-label" }, [
                    _createTextVNode("Cont Bancă "),
                    _createElementVNode("span", { class: "genpo-optional" }, "(opțional)")
                  ], -1)),
                  _createVNode(_unref(DxSelectBox), {
                    value: facturaProiectDraft.value.ContBancaCasaId,
                    "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((facturaProiectDraft.value.ContBancaCasaId) = $event)),
                    "data-source": dsBanciConturi.value,
                    "display-expr": (item) => item ? `${item.Cod || ''} – ${item.CodIban || item.Nume || ''}`.trim() : '',
                    "value-expr": "Id",
                    "search-enabled": true,
                    "search-expr": "Cod",
                    "show-clear-button": true,
                    placeholder: "Selectează contul bancar..."
                  }, null, 8, ["value", "data-source", "display-expr"])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _cache[25] || (_cache[25] = _createElementVNode("label", { class: "genpo-label" }, [
                    _createTextVNode("Observații "),
                    _createElementVNode("span", { class: "genpo-optional" }, "(opțional)")
                  ], -1)),
                  _createVNode(_unref(DxTextBox), {
                    value: facturaProiectDraft.value.Observatii,
                    "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((facturaProiectDraft.value.Observatii) = $event)),
                    "show-clear-button": true,
                    placeholder: "Observații factură proiect..."
                  }, null, 8, ["value"])
                ])
              ]),
              _cache[26] || (_cache[26] = _createElementVNode("p", { class: "genpo-hint" }, [
                _createElementVNode("i", {
                  class: "dx-icon dx-icon-info",
                  style: {"font-size":"13px","vertical-align":"middle"}
                }),
                _createTextVNode(" Selectează comenzile din proiect care intră în factură — toate au fost bifate implicit. Comenzile selectate trebuie să aibă același PO (Nr. Contract). ")
              ], -1)),
              _createVNode(_unref(DxDataGrid), {
                "data-source": dsComenziProiect.value,
                "key-expr": "Id",
                "show-borders": false,
                "show-column-lines": false,
                "show-row-lines": true,
                "row-alternation-enabled": true,
                "hover-state-enabled": true,
                height: "220",
                onContentReady: onComenziProiectContentReady,
                onSelectionChanged: onComenziProiectSelectionChanged
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DxSelection), {
                    mode: "multiple",
                    "show-check-boxes-mode": "always"
                  }),
                  _createVNode(_unref(DxColumn), {
                    "data-field": "Cod",
                    caption: "Comandă",
                    width: 130
                  }),
                  _createVNode(_unref(DxColumn), {
                    "data-field": "DataComenzii",
                    caption: "Data",
                    "data-type": "date",
                    format: "dd.MM.yyyy",
                    width: 100,
                    alignment: "center"
                  }),
                  _createVNode(_unref(DxColumn), {
                    "data-field": "NumarContract",
                    caption: "PO (Nr. Contract)"
                  }),
                  _createVNode(_unref(DxColumn), {
                    "data-field": "TotalComanda",
                    caption: "Total",
                    "data-type": "number",
                    format: formatRO,
                    width: 120,
                    alignment: "right"
                  })
                ]),
                _: 1
              }, 8, ["data-source"])
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createVNode(_unref(DxButton), {
              text: "Anulează",
              "styling-mode": "outlined",
              disabled: isGenerandFacturaProiect.value,
              onClick: _cache[10] || (_cache[10] = ($event: any) => (showFacturaProiectPopup.value = false))
            }, null, 8, ["disabled"]),
            _createVNode(_unref(DxButton), {
              text: isGenerandFacturaProiect.value ? 'Se generează...' : 'Generează Factură Proiect',
              type: "default",
              disabled: isGenerandFacturaProiect.value || !facturaProiectDraft.value.TipDocumentId || selectedComenziIds.value.length === 0,
              onClick: onGenereazaFacturaProiect
            }, null, 8, ["text", "disabled"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(PopupAdaugareDetaliu, {
      visible: showAddPopup.value,
      "onUpdate:visible": _cache[12] || (_cache[12] = ($event: any) => ((showAddPopup).value = $event)),
      "tip-comanda": selectedTipComanda.value,
      "comanda-id": selectedComandaId.value,
      onSaved: onSaved
    }, null, 8, ["visible", "tip-comanda", "comanda-id"]),
    _createVNode(_unref(DxPopup), {
      visible: showDocumentePopup.value,
      "show-title": false,
      "show-close-button": false,
      width: 860,
      height: 540,
      "drag-enabled": true,
      onHidden: _cache[14] || (_cache[14] = ($event: any) => (showDocumentePopup.value = false)),
      "wrapper-attr": { class: 'doc-popup-no-padding' }
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _cache[28] || (_cache[28] = _createElementVNode("i", { class: "dx-icon dx-icon-doc popup-hdr-icon" }, null, -1)),
            _createElementVNode("div", _hoisted_25, [
              _cache[27] || (_cache[27] = _createElementVNode("span", { class: "popup-hdr-title" }, "Documente generate", -1)),
              _createElementVNode("span", _hoisted_26, "Comandă: " + _toDisplayString(selectedContextOrder.value?.Cod), 1)
            ]),
            _createElementVNode("button", {
              class: "popup-close-x",
              onClick: _cache[13] || (_cache[13] = ($event: any) => (showDocumentePopup.value = false))
            }, "×")
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createVNode(_unref(DxDataGrid), {
              "data-source": dsDocumente.value,
              "key-expr": "Id",
              "show-borders": false,
              "show-column-lines": false,
              "show-row-lines": true,
              "row-alternation-enabled": true,
              "hover-state-enabled": true,
              "column-auto-width": false,
              height: "420",
              onRowClick: onDocRowClick
            }, {
              totalDocCell: _withCtx(({ data }) => [
                _createElementVNode("span", _hoisted_28, _toDisplayString(data.value != null ? formatRO(data.value) : '—'), 1)
              ]),
              anulatCell: _withCtx(({ data }) => [
                (data.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_29, "DA"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_30, "—"))
              ]),
              default: _withCtx(() => [
                _createVNode(_unref(DxColumn), {
                  "data-field": "TipCod",
                  caption: "Tip",
                  width: 85
                }),
                _createVNode(_unref(DxColumn), {
                  "data-field": "TipNume",
                  caption: "Denumire tip"
                }),
                _createVNode(_unref(DxColumn), {
                  "data-field": "ComandaCod",
                  caption: "Comandă",
                  width: 110
                }),
                _createVNode(_unref(DxColumn), {
                  "data-field": "Numar",
                  caption: "Număr",
                  width: 130
                }),
                _createVNode(_unref(DxColumn), {
                  "data-field": "Data",
                  caption: "Data",
                  "data-type": "date",
                  format: "dd.MM.yyyy",
                  width: 100
                }),
                _createVNode(_unref(DxColumn), {
                  "data-field": "Total",
                  caption: "Total",
                  "data-type": "number",
                  format: formatRO,
                  width: 130,
                  alignment: "right",
                  "cell-template": "totalDocCell"
                }),
                _createVNode(_unref(DxColumn), {
                  "data-field": "Anulat",
                  caption: "Anulat",
                  "data-type": "boolean",
                  width: 75,
                  "cell-template": "anulatCell"
                })
              ]),
              _: 1
            }, 8, ["data-source"])
          ]),
          (isLoadingDocumente.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_31, "Se încarcă documentele..."))
            : (dsDocumente.value.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [...(_cache[29] || (_cache[29] = [
                  _createElementVNode("i", { class: "dx-icon dx-icon-info" }, null, -1),
                  _createTextVNode(" Niciun document generat pentru această comandă. ", -1)
                ]))]))
              : (_openBlock(), _createElementBlock("div", _hoisted_33, [...(_cache[30] || (_cache[30] = [
                  _createElementVNode("i", { class: "dx-icon dx-icon-info" }, null, -1),
                  _createTextVNode(" Include și documentele altor comenzi cu același PO (Proiect) — coloana „Comandă\" arată sursa. Click pe un rând pentru a deschide documentul într-un tab nou ", -1)
                ]))]))
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_unref(DxPopup), {
      visible: showDocumentViewPopup.value,
      "show-title": false,
      "show-close-button": false,
      width: 980,
      height: 660,
      "drag-enabled": true,
      onHidden: _cache[16] || (_cache[16] = ($event: any) => (showDocumentViewPopup.value = false)),
      "wrapper-attr": { class: 'doc-popup-no-padding' }
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _cache[31] || (_cache[31] = _createElementVNode("i", { class: "dx-icon dx-icon-doc popup-hdr-icon" }, null, -1)),
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("span", _hoisted_37, _toDisplayString(selectedDocument.value?.Tip?.Cod) + " " + _toDisplayString(selectedDocument.value?.Numar), 1),
              _createElementVNode("span", _hoisted_38, _toDisplayString(selectedDocument.value?.Tip?.Nume), 1)
            ]),
            (selectedDocument.value?.Anulat)
              ? (_openBlock(), _createElementBlock("span", _hoisted_39, "ANULAT"))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              class: "popup-close-x",
              onClick: _cache[15] || (_cache[15] = ($event: any) => (showDocumentViewPopup.value = false))
            }, "×")
          ]),
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("div", _hoisted_41, [
              _cache[32] || (_cache[32] = _createElementVNode("span", { class: "meta-block-label" }, "Data", -1)),
              _createElementVNode("span", _hoisted_42, _toDisplayString(formatDocDate(selectedDocument.value?.Data)), 1)
            ]),
            _cache[36] || (_cache[36] = _createElementVNode("div", { class: "meta-divider" }, null, -1)),
            _createElementVNode("div", _hoisted_43, [
              _cache[33] || (_cache[33] = _createElementVNode("span", { class: "meta-block-label" }, "Valoare", -1)),
              _createElementVNode("span", _hoisted_44, _toDisplayString(formatDocMoney(selectedDocument.value?.Valoare)), 1)
            ]),
            _cache[37] || (_cache[37] = _createElementVNode("div", { class: "meta-divider" }, null, -1)),
            _createElementVNode("div", _hoisted_45, [
              _cache[34] || (_cache[34] = _createElementVNode("span", { class: "meta-block-label" }, "TVA", -1)),
              _createElementVNode("span", _hoisted_46, _toDisplayString(formatDocMoney(selectedDocument.value?.ValoareTva)), 1)
            ]),
            _cache[38] || (_cache[38] = _createElementVNode("div", { class: "meta-divider" }, null, -1)),
            _createElementVNode("div", _hoisted_47, [
              _cache[35] || (_cache[35] = _createElementVNode("span", { class: "meta-block-label" }, "Total", -1)),
              _createElementVNode("span", _hoisted_48, _toDisplayString(formatDocMoney(selectedDocument.value?.Total)), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_49, [
            _createVNode(_unref(DxDataGrid), {
              "data-source": dsLinii.value,
              "key-expr": "Id",
              "show-borders": false,
              "show-column-lines": false,
              "show-row-lines": true,
              "row-alternation-enabled": true,
              "hover-state-enabled": true,
              "column-auto-width": false,
              height: "510"
            }, {
              totalLinieCell: _withCtx(({ data }) => [
                _createElementVNode("span", _hoisted_50, _toDisplayString(data.value != null ? formatRO(data.value) : '—'), 1)
              ]),
              default: _withCtx(() => [
                _createVNode(_unref(DxColumn), {
                  "data-field": "Produs.Cod",
                  caption: "Cod",
                  width: 105
                }),
                _createVNode(_unref(DxColumn), {
                  "data-field": "Produs.Nume",
                  caption: "Produs",
                  "calculate-display-value": getLinieNume
                }),
                _createVNode(_unref(DxColumn), {
                  "data-field": "Cantitate",
                  caption: "Cant.",
                  "data-type": "number",
                  format: formatRO,
                  width: 85,
                  alignment: "right"
                }),
                _createVNode(_unref(DxColumn), {
                  "data-field": "PretUnitar",
                  caption: "Preț unitar",
                  "data-type": "number",
                  format: formatRO,
                  width: 115,
                  alignment: "right"
                }),
                _createVNode(_unref(DxColumn), {
                  "data-field": "Tva",
                  caption: "TVA %",
                  "data-type": "number",
                  width: 75,
                  alignment: "center"
                }),
                _createVNode(_unref(DxColumn), {
                  "data-field": "Valoare",
                  caption: "Valoare",
                  "data-type": "number",
                  format: formatRO,
                  width: 120,
                  alignment: "right"
                }),
                _createVNode(_unref(DxColumn), {
                  "data-field": "ValoareTva",
                  caption: "Val. TVA",
                  "data-type": "number",
                  format: formatRO,
                  width: 110,
                  alignment: "right"
                }),
                _createVNode(_unref(DxColumn), {
                  "data-field": "Total",
                  caption: "Total",
                  "data-type": "number",
                  format: formatRO,
                  width: 120,
                  alignment: "right",
                  "cell-template": "totalLinieCell"
                })
              ]),
              _: 1
            }, 8, ["data-source"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})